import { css } from '@emotion/react';

const titledSectionStyles = css`
    .section-title {
        cursor: pointer;
        display: flex;
        align-items: center;

        .icon {
            background: none;
            border: none;
        }

        .icon-right {
            margin-left: auto;
        }

        .icon-left {
            margin-right: 0.5rem;
        }
    }

    .wrapper {
        overflow: hidden;
    }

    .wrapper--show {
        height: auto;
    }

    .wrapper--hidden {
        height: 0px;
    }

    .section--top {
        display: flex;
    }

    .toggle-section {
        display: none;
        width: 100%;
    }

    .show {
        display: inline-block;
    }

    .switch {
        position: relative;
        display: inline-block;
        width: 6.25rem;
        height: 2rem;
        margin-left: auto;

        .toggle-label {
            position: relative;
            z-index: 1;
            font-size: 0.8rem;
            padding: 0.4rem;
            background: none;
            border: none;
        }

        .slider {
            display: flex;
            position: absolute;
            cursor: pointer;
            background-color: #ccc;
            transition: 0.4s;
            border-radius: 2.5rem;
            height: 2rem;

            &:before {
                position: absolute;
                content: '';
                width: 2.5rem;
                height: 1.5rem;
                border: 1px solid #fff;
                border-radius: 1.25rem;
                left: 0.25em;
                bottom: 0.25em;
                background-color: white;
                transition: 0.4s;
            }
        }

        .toggle--off:before {
            transform: translateX(96%);
        }
    }

    .switch.switch-fr {
        margin-left: 72%;
        .slider {
            &:before {
                width: 68px;
            }
        }
    }
`;

export const themetitledSectionStyles = css`
    font-family: var(--font-family-regular);
    background-color: var(--default-background-color);

    .section-title {
        font-family: var(--font-family-regular);
        color: var(--default-text-color);
        font-weight: var(--font-weight-regular);
        font-size: var(--font-size-regular);
        cursor: pointer;
        display: flex;
        align-items: center;

        .icon {
            color: var(--default-text-color);
            background: none;
            border: none;
        }

        .icon-right {
            margin-left: auto;
        }

        .icon-left {
            margin-right: 0.5rem;
        }
    }

    .wrapper {
        overflow: hidden;
    }

    .wrapper--show {
        height: auto;
    }

    .wrapper--hidden {
        height: 0px;
    }

    .section--top {
        display: flex;
    }

    .toggle-section {
        display: none;
        width: 100%;
    }

    .show {
        display: inline-block;
    }

    .switch {
        position: relative;
        display: inline-block;
        width: 6.25rem;
        height: 2rem;
        margin-left: auto;

        .toggle-label {
            font-family: var(--font-family-regular);
            position: relative;
            z-index: 1;
            font-size: 0.8rem;
            padding: 0.4rem;
            background: none;
            border: none;
        }

        .slider {
            display: flex;
            position: absolute;
            cursor: pointer;
            background-color: var(--color-grey);
            transition: 0.4s;
            border-radius: 2.5rem;
            height: 2rem;

            &:before {
                position: absolute;
                content: '';
                width: 2.5rem;
                height: 1.5rem;
                border: 1px solid var(--color-white);
                border-radius: 1.25rem;
                left: 0.25em;
                bottom: 0.25em;
                background-color: var(--color-white);
                transition: 0.4s;
            }
        }

        .toggle--off:before {
            transform: translateX(96%);
        }
    }

    .switch.switch-fr {
        margin-left: 72%;
        .slider {
            &:before {
                width: 68px;
            }
        }
    }
`;

export default titledSectionStyles;
